import { render, staticRenderFns } from "./historicMessageSms.vue?vue&type=template&id=caab5edc&"
import script from "./historicMessageSms.js?vue&type=script&lang=js&"
export * from "./historicMessageSms.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports